var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormGroup',[_c('Button',{attrs:{"primary":"","type":"button"},on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(_vm._s(_vm.open ? _vm.labelClosed : _vm.labelOpen))])],1),(_vm.open)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }